import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const testimonials = [
    {
        id: 1,
        quote: "Getting a home estimate through Pembre was fast and accurate, and the contractor referrals saved me hours of searching. Every recommendation was professional and reliable.",
        author: "Sarah M.",
        role: "Homeowner"
    },
    {
        id: 2,
        quote: "Pembre stepped in when I was at risk of losing my home. They walked me through my options, connected me with the right resources, and ultimately helped me avoid foreclosure. I’m genuinely grateful.",
        author: "David K.",
        role: "Homeowner"
    }
];

export default function Testimonials() {
    return (
        <div className="bg-light py-5">
            <Container>
                <div className="text-center mb-5">
                    <h2 className="fw-bold">What People Say About Us</h2>
                    <div className="bg-primary mx-auto mt-3" style={{ width: '60px', height: '4px' }}></div>
                </div>
                <Row className="justify-content-center">
                    {testimonials.map(t => (
                        <Col key={t.id} md={6} lg={4} className="mb-4">
                            <Card className="h-100 border-0 shadow-sm text-center p-4">
                                <Card.Body>
                                    <div className="fs-1 text-primary mb-3">❝</div>
                                    <Card.Text className="fs-5 fst-italic mb-4">
                                        "{t.quote}"
                                    </Card.Text>
                                    <Card.Footer className="bg-white border-0">
                                        <div className="fw-bold">{t.author}</div>
                                        <small className="text-muted">{t.role}</small>
                                    </Card.Footer>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}
